import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { GroupPeopleQuery } from 'services/apollo/queries';
import Modal from 'react-modal';
import { CollaboratorAvatar, SelectButton } from 'components';
import { AddGroupMemberModal } from './AddGroupMemberModal';
import classNames from 'classnames';

import groupStyles from './GroupStyles.module.scss';
import styles from './GroupPeople.module.scss';
import modalStyles from './AddGroupMemberModal.module.scss';

export const GroupPeople = () => {
  const { groupId } = useParams();
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const { error, data } = useQuery(GroupPeopleQuery, {
    variables: { groupId },
    fetchPolicy: 'cache-and-network',
  });

  if (data === undefined || data?.groupById == null) return <GroupPeopleLoader />;

  if (error) return <GroupPeopleLoader />;

  return (
    <div className={classNames(styles.container, groupStyles.module)}>
      <div className={groupStyles.heading}>People</div>
      <div className={styles.peopleContainer}>
        {data?.groupById?.members.map((member: any, key: number) => (
          <Link className={styles.avatarLink} key={key} to={`/profile/${member.id}`}>
            <CollaboratorAvatar
              bordered={false}
              collaborator={{
                displayName: member.name,
                emailAddress: member.email,
                photoURL: member.avatarUrl,
              }}
              key={key}
              size="Large"
            />
          </Link>
        ))}
        <SelectButton
          className={styles.addPersonButton}
          size="L"
          noBorder
          onOpenModal={() => {
            setModalIsOpen(true);
          }}
        />
      </div>

      {/* Leave Group Modal*/}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => {
          setModalIsOpen(false);
        }}
        //@ts-ignore
        className={modalStyles.addGroupMemberModal}
        overlayClassName={modalStyles.addGroupMemberModalOverlay}
      >
        <AddGroupMemberModal
          onCancel={() => {
            setModalIsOpen(false);
          }}
        />
      </Modal>
    </div>
  );
};

export const GroupPeopleLoader = () => {
  return (
    // TODO - Extract
    <div
      className={classNames(styles.container, groupStyles.module)}
      style={{ height: '171px' }}
    ></div>
  );
};
